// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select{position:absolute;top:20px;right:20px;color:#fff;appearance:none;padding:4px 8px;background:#1277a2;border:1px solid #000;border-radius:4px;text-align:center;width:100%;max-width:fit-content;cursor:pointer;z-index:999}", ""]);
// Exports
module.exports = exports;
